import React from "react";
import { MessageCircle, Mail, ArrowRight } from "lucide-react";
import { useContent } from "@/contexts/ContentContext";
import { buildWhatsAppLink, buildMailLink, renderTemplate } from "@/lib/cta";
import { trackCta } from "@/lib/analytics";

export const Contact = () => {
    const { content } = useContent();
    const c = content.contact;

    const whatsappHref = buildWhatsAppLink(c.whatsapp_number, renderTemplate(c.whatsapp_template, { area: "" }));
    const mailHref = buildMailLink(c.email, c.email_subject, renderTemplate(c.email_template, { area: "" }));

    return (
        <section id="contact" data-testid="contact-section" className="bg-[#0A192F] text-white py-24 lg:py-28 relative overflow-hidden">
            <div className="absolute -bottom-32 -left-32 w-[460px] h-[460px] bg-teal-500/10 blur-3xl rounded-full pointer-events-none" />
            <div className="max-w-5xl mx-auto px-6 md:px-10 text-center relative">
                <p className="label-eyebrow !text-teal-300">{c.eyebrow}</p>
                <h2 data-testid="contact-title" className="mt-4 font-display font-semibold text-white text-3xl sm:text-4xl lg:text-[44px] leading-[1.1] tracking-tight">{c.title}</h2>
                <p className="mt-5 max-w-2xl mx-auto text-base lg:text-lg text-slate-300 font-body leading-relaxed">{c.intro}</p>

                <div className="mt-12 grid sm:grid-cols-2 gap-5 max-w-2xl mx-auto">
                    <a
                        href={whatsappHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="contact-whatsapp-card"
                        onClick={() => trackCta("whatsapp_click", { source: "contact_section" })}
                        className="group border border-white/15 bg-white/[0.04] hover:bg-white/[0.08] hover:border-teal-400/50 p-7 text-left transition-all"
                    >
                        <div className="flex items-center justify-between">
                            <span className="inline-flex items-center justify-center w-11 h-11 bg-teal-600 text-white">
                                <MessageCircle strokeWidth={1.5} className="w-5 h-5" />
                            </span>
                            <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-teal-300 group-hover:translate-x-1 transition-all" />
                        </div>
                        <p className="mt-5 text-[12px] uppercase tracking-[0.2em] text-slate-400">WhatsApp</p>
                        <p className="mt-2 font-display text-xl font-semibold text-white">{c.whatsapp_display}</p>
                        <p className="mt-1 text-[13px] text-slate-400">WhatsApp Aurea Digital Solutions</p>
                    </a>

                    <a
                        href={mailHref}
                        data-testid="contact-email-card"
                        onClick={() => trackCta("email_click", { source: "contact_section" })}
                        className="group border border-white/15 bg-white/[0.04] hover:bg-white/[0.08] hover:border-teal-400/50 p-7 text-left transition-all"
                    >
                        <div className="flex items-center justify-between">
                            <span className="inline-flex items-center justify-center w-11 h-11 bg-white text-[#0A192F]">
                                <Mail strokeWidth={1.5} className="w-5 h-5" />
                            </span>
                            <ArrowRight className="w-5 h-5 text-slate-400 group-hover:text-teal-300 group-hover:translate-x-1 transition-all" />
                        </div>
                        <p className="mt-5 text-[12px] uppercase tracking-[0.2em] text-slate-400">Email</p>
                        <p className="mt-2 font-display text-xl font-semibold text-white break-all">{c.email}</p>
                        <p className="mt-1 text-[13px] text-slate-400">Email Aurea Digital Team</p>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Contact;
